import CheckoutPage from '../pages/CheckoutPage/CheckoutPage';
import CoverableDetailsPage from '../pages/CoverableDetailsPage/CoverableDetailsPage';
import ReceiptPage from '../pages/ReceiptPage/ReceiptPage';
import ShoppingBasketPage from '../pages/ShoppingBasketPage/ShoppingBasketPage';
import ShoppingBasketSummaryPage from '../pages/ShoppingBasketSummaryPage/ShoppingBasketSummaryPage';
import CoverableInformationPage from '../pages/CoverableInformationPage/CoverableInformationPage';
import ClaimsHistoryPage from '../pages/ClaimsHistoryPage/ClaimsHistoryPage';
import CustomerIdentificationPage from '../pages/CustomerIdentificationPage/CustomerIdentificationPage';
import CprQuestionPage from '../pages/CprQuestionPage/CprQuestionPage';
import CoveragePackagePage from '../pages/CoveragePackagePage/CoveragePackagePage';
import AdditionalCoveragePage from '../pages/AdditionalCoveragePage/AdditionalCoveragePage';
import ProductSelectorPage from '../pages/ProductSelectorPage/ProductSelectorPage';
import QuoteExpiredContent from '../pages/QuoteExpiredPage/components/QuoteExpiredContent';
import OpcEntryPage from '../pages/OpcEntryPage/OpcEntryPage';
import AdjustDetailsPage from '../pages/AdjustDetailsPage/AdjustDetailsPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import MitIdLoginPage from '../pages/MitIdLoginPage/MitIdLoginPage';
import AdditionalInformationPage from '../pages/AdditionalInformationPage/AdditionalInformationPage';
import PostLoginQuestionsPage from '../pages/PostLoginQuestionsPage/PostLoginQuestionsPage';
import ResumeOnsaPage from '../pages/ResumeOnsaPage/ResumeOnsaPage';
import MPSActivationPage from '../pages/MPSActivationPage/MPSActivationPage';
import MPSAgreementStatusPage from '../pages/MPSAgreementStatusPage/MPSAgreementStatusPage';

type WizardPageComponent = () => React.JSX.Element;

const wizardPages = [
    {
        name: 'ProductSelectorPage',
        Component: ProductSelectorPage,
        shouldRemovePadding: false
    },
    {
        name: 'CoverableInformationPage',
        Component: CoverableInformationPage,
        shouldRemovePadding: false
    },
    {
        name: 'ClaimsHistoryPage',
        Component: ClaimsHistoryPage,
        shouldRemovePadding: false
    },
    {
        name: 'AdditionalInformationPage',
        Component: AdditionalInformationPage,
        shouldRemovePadding: false
    },
    {
        name: 'CustomerIdentificationPage',
        Component: CustomerIdentificationPage,
        shouldRemovePadding: false
    },
    {
        name: 'CprQuestionPage',
        Component: CprQuestionPage,
        shouldRemovePadding: false
    },
    {
        name: 'PostLoginQuestionsPage',
        Component: PostLoginQuestionsPage,
        shouldRemovePadding: false
    },
    {
        name: 'CoveragePackagePage',
        Component: CoveragePackagePage,
        shouldRemovePadding: true
    },
    {
        name: 'AdditionalCoveragePage',
        Component: AdditionalCoveragePage,
        shouldRemovePadding: false
    },
    {
        name: 'MitIdLoginPage',
        Component: MitIdLoginPage,
        shouldRemovePadding: false
    },
    {
        name: 'LandingPage',
        Component: LandingPage,
        shouldRemovePadding: true
    },
    {
        name: 'ShoppingBasketPage',
        Component: ShoppingBasketPage,
        shouldRemovePadding: false
    },
    {
        name: 'CoverableDetailsPage',
        Component: CoverableDetailsPage,
        shouldRemovePadding: false
    },
    {
        name: 'AdjustDetailsPage',
        Component: AdjustDetailsPage,
        shouldRemovePadding: false
    },
    {
        name: 'ShoppingBasketSummaryPage',
        Component: ShoppingBasketSummaryPage,
        shouldRemovePadding: false
    },
    {
        name: 'CheckoutPage',
        Component: CheckoutPage,
        shouldRemovePadding: false
    },
    {
        name: 'ReceiptPage',
        Component: ReceiptPage,
        shouldRemovePadding: false
    },
    {
        name: 'ExpiredPage',
        Component: QuoteExpiredContent,
        shouldRemovePadding: false
    },
    {
        name: 'OpcEntryPage',
        Component: OpcEntryPage,
        shouldRemovePadding: false
    },
    {
        name: 'ResumeOnsaPage',
        Component: ResumeOnsaPage,
        shouldRemovePadding: false
    },
    {
        name: 'MPSActivationPage',
        Component: MPSActivationPage,
        shouldRemovePadding: false
    },
    {
        name: 'MPSAgreementStatusPage',
        Component: MPSAgreementStatusPage,
        shouldRemovePadding: false
    }
] as const;

type WizardPageComponentName = (typeof wizardPages)[number]['name'];

const pageIndex = (pageName: WizardPageComponentName): number =>
    wizardPages.findIndex((page) => page.name === pageName) + 1;

const pageName = (pageIndex: number): WizardPageComponentName | undefined =>
    wizardPages[pageIndex - 1]?.name ?? '';

export { wizardPages, pageIndex, pageName };
export type { WizardPageComponentName, WizardPageComponent };
